import { useGetEntityDetailsByIdQuery } from 'src/api/redux';

export const useGetEntityDetailsById = ({
  id,
  type,
  shouldRefetch = false,
}: {
  id: string;
  type: string;
  shouldRefetch: boolean;
}) => {
  const shouldFetch = id && type !== 'hcp-group';

  const { data, error, isFetching, isLoading, refetch } =
    useGetEntityDetailsByIdQuery(
      { id },
      {
        skip: !shouldFetch,
        pollingInterval: shouldRefetch ? 60000 : 0,
      }
    );

  return {
    data,
    error,
    isValidating: isFetching,
    isLoading,
    refetch,
  };
};

export default useGetEntityDetailsById;
